import { render } from "./ModalDocumentCreateProgress.vue?vue&type=template&id=33144f86&scoped=true"
import script from "./ModalDocumentCreateProgress.vue?vue&type=script&lang=js"
export * from "./ModalDocumentCreateProgress.vue?vue&type=script&lang=js"

import "./ModalDocumentCreateProgress.vue?vue&type=style&index=0&id=33144f86&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33144f86"]])

export default __exports__